import { Params } from 'app/types';

import { API_URL } from '../../core/config';
import { request } from '../config';

const MA_URL = 'users/merchant_accounts.json';
const MA_DASHBOARD_URL = 'users/merchant_accounts/stripe_dashboard_url.json';

export function apiGetMerchantAccount(): Promise<any> {
  return request(
    {
      url: MA_URL,
      method: 'GET',
      baseURL: API_URL,
    },
    (data) => data.model
  );
}

export function apiGetMerchantAccountConnectLink(
  returnUrl: string
): Promise<Params> {
  return request(
    {
      url: MA_URL,
      method: 'POST',
      baseURL: API_URL,
      data: {
        return_url: returnUrl,
      },
    },
    (data) => data.model
  );
}

export function apiGetMerchantAccountDashboardLink(
  returnUrl: string
): Promise<Params> {
  return request(
    {
      url: MA_DASHBOARD_URL,
      method: 'GET',
      baseURL: API_URL,
      params: {
        return_url: returnUrl,
      },
    },
    (data) => data.model
  );
}

export function apiDeleteMerchantAccount(): Promise<string> {
  return request(
    {
      url: MA_URL,
      method: 'DELETE',
      baseURL: API_URL,
    },
    (data) => data.model.id
  );
}
